import { render, staticRenderFns } from "./health-record-message.vue?vue&type=template&id=5ea5af14&"
import script from "./health-record-message.vue?vue&type=script&lang=js&"
export * from "./health-record-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports